import React, { useEffect, useState } from "react";
import { Box, Grid, Link, Paper, Typography } from "@mui/material";
import { useFormik } from "formik";
import axios from "axios";
import * as yup from "yup";
import { BASE_URL } from "../../utils/config";
import { toastify } from "../../components/base/Toastify/Toastify";
import TTextField from "../../components/base/TTextField/TTextField";
import PasswordField from "../../components/base/PasswodField/PasswordField";
import PrimaryButton from "../../components/base/PrimaryButton/PrimaryButton";
import "../../assets/scss/login.scss";
import imgShape1 from "../../assets/images/home/shape1.png";
import logo34 from "../../assets/images/home/logo-34.png";
import useCustomLoader from "../../hooks/useCustomLoader";
import Loader from "../../components/base/Loader/Loader";

export default function Login(props) {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => setShowPassword(!showPassword);
  const { openCustomLoader, closeCustomLoader, customLoading } =
    useCustomLoader();

  useEffect(() => {
    if (
      window.location.pathname === "/login/expire" &&
      !localStorage.getItem("temp")
    ) {
      toastify("ERROR", "Хандах хугацаа дууссан.");
    }
    closeCustomLoader();
  }, []);

  const validationSchema = yup.object({
    username: yup.string().required("Нэвтрэх нэрээ оруулна уу."),
    password: yup
      .string()
      .min(8, "Нууц үг багадаа 8 тэмдэгт байх ёстой.")
      .required("Нууц үгээ оруулна уу."),
  });

  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      let params = {
        userName: values.username,
        password: values.password,
      };

      openCustomLoader();
      axios
        .post(BASE_URL + "/auth", params, {
          withCredentials: true,
        })
        .then((resLogin) => {
          if (resLogin.data.SUCCESS_CODE === 200) {
            const token = resLogin.data.access_token;
            const config = {
              headers: {
                Authorization: "Bearer " + token,
              },
            };

            axios
              .post(BASE_URL + "/signin", params, config)
              .then((res) => {
                closeCustomLoader();
                if (res.data.SUCCESS_CODE === 200) {
                  console.log("res", res);
                  localStorage.setItem("username", values.username);
                  const data = res.data.RESULT;
                  if (
                    data.groupName === "teacher" ||
                    data.groupName === "watchman"
                  ) {
                    props.setLogged(data);
                  } else {
                    localStorage.clear();
                    toastify("WARNING", "Нэвтрэх эрхгүй хэрэглэгч байна.");
                  }
                } else {
                  toastify("WARNING", res.data.message);
                }
              })
              .catch((err) => {
                closeCustomLoader();
                console.log("error sign in: ", err);
              });
          } else {
            localStorage.clear();
            closeCustomLoader();
            toastify("WARNING", "Нэвтрэх нэр эсвэл нууц үг буруу байна.");
          }
        })
        .catch((error) => {
          closeCustomLoader();
          console.log("aaaaaaaa", error);
          toastify("WARNING", "Сервертэй холбогдоход алдаа гарлаа.");
        });
    },
  });

  return (
    <>
      <Box className="bg-login">
        {customLoading && <Loader />}
        <img src={imgShape1} className="bg-shape" alt="background shape" />
        <Box className="container">
          <Grid container spacing={1}>
            <Grid item xs={8} className="left-content">
              {/* <Stack direction="row" spacing={2} sx={{ mb: 5 }}>
              <img src={logoYam} height={54}></img>
              <img src={logoESIS} height={54}></img>
            </Stack> */}

              {/* <Box sx={{ maxWidth: "240px", mb: 8 }}>
              <Typography variant="h4">Тавтай морилно уу</Typography>
              <Typography variant="body1">
                Багшийн мэргэжил гэдэг бол хүний сэтгэлийн эмзэг нандин ертөнцөд
                тасралтгүй нэвтрэн орох ХҮН судлалын мэргэжил билээ.
              </Typography>
            </Box> */}
            </Grid>
            <Grid item xs={4}>
              <Box sx={{ my: 5 }}>
                <img src={logo34} alt="logo" />
              </Box>
              <Box
                sx={{
                  height: "80%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <form onSubmit={handleSubmit}>
                  <Paper
                    sx={{
                      px: 4,
                      py: 5,
                      width: "100%",
                      // boxShadow: "rgba(100, 116, 139, 0.12) 0px 10px 15px",
                    }}
                    elevation={0}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography variant="h6">Багшийн систем</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TTextField
                          id="username"
                          name="username"
                          label="Нэвтрэх нэр"
                          value={values.username}
                          fullWidth
                          helperText={touched.username && errors.username}
                          error={touched.username && Boolean(errors.username)}
                          onChange={handleChange}
                          // onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <PasswordField
                          id="password"
                          name="password"
                          label="Нууц үг"
                          type={showPassword ? "text" : "password"}
                          showPassword={showPassword}
                          fullWidth
                          helperText={touched.password && errors.password}
                          error={touched.password && Boolean(errors.password)}
                          handleShowPassword={handleShowPassword}
                          handleChangePassword={handleChange}
                          // onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={12} display="flex" justifyContent="end">
                        <Link href="password/recover" variant="body2">
                          Нууц үг сэргээх
                        </Link>
                      </Grid>

                      <Grid item xs={12}>
                        {/* <Divider /> */}
                        <PrimaryButton
                          type="submit"
                          variant="contained"
                          size="large"
                          fullWidth>
                          Нэвтрэх
                        </PrimaryButton>
                      </Grid>
                    </Grid>
                  </Paper>
                </form>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box className="footer-org-name">
          <Typography align="center" color="text.secondary">
            © 2023 Боловсролын мэдээллийн технологийн төв
          </Typography>
        </Box>
      </Box>
    </>
  );
}
